function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('../Components', true, /\.js$/));
requireAll(require.context('../Scripts/components', true, /\.js$/));